// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_wF-","cls2":"TopBar-cls2_qpL TopBar-cls1_wF-"};